import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

export const collectorTransactionStart=()=>{
    return {
        type:actionTypes.COLLECTOR_TRANSACTION_START,
    }
}

export const collectorTransactionSuccess=()=>{
    return {
        type:actionTypes.COLLECTOR_TRANSACTION_SUCCESS
    }
}

export const collectorTransactionFail=(data)=>{
    return {
        type:actionTypes.COLLECTOR_TRANSACTION_FAIL,
        payload:data
    }
}

export const collectorTransaction=(request,token)=>{
    return async dispatch=>{
        dispatch(collectorTransactionStart());
        let url=`${api}/transactions/collector_transaction`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data:request
          };
          axios(options)
              .then(response => {
              dispatch(collectorTransactionSuccess());
            })
            .catch(err => {
              dispatch(collectorTransactionFail(err));
            });
    }
}

export const collectorHistoryStart=()=>{
    return {
        type:actionTypes.COLLECTOR_HISTORY_START,
    }
}

export const collectorHistorySuccess=(data)=>{
    return {
        type:actionTypes.COLLECTOR_HISTORY_SUCCESS,
        payload:data
    }
}

export const collectorHistoryFail=(err)=>{
    return {
        type:actionTypes.COLLECTOR_HISTORY_FAIL,
        payload:err
    }
}

export const collectorHistory=(request,token)=>{
    return async dispatch=>{
        dispatch(collectorHistoryStart());
        let url=`${api}/transactions/collector_transactions/${request.employeeId}/${request.startDate}/${request.endDate}`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token
            },
            data:{}
          };
          axios(options)
              .then(response => {
              dispatch(collectorHistorySuccess(response.data));
            })
            .catch(err => {
              dispatch(collectorHistoryFail(err));
            });
    }
}